<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    class="select-container"
    :style="{
      '--schema-color': schemaPrimaryColor,
    }"
  >
    <div
      v-if="!fullScreenLoading && businessEntity != null"
      class="header mt-70"
    >
      <div
        class="header-logo"
        v-if="businessEntity.logo"
      >
        <img
          :src="
            `https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${
              businessEntity.logo
            }?t=${new Date().getTime()}`
          "
          alt="Tippie"
        >
        <h2>{{ businessEntity.name }}</h2>
      </div>
      <p class="header-title">
        {{ $t("select-employee.title") }}
      </p>
    </div>
    <div
      v-if="!fullScreenLoading && employees.length"
      class="body"
    >
      <el-row class="body-multiple">
        <p class="body-multiple__title">
          {{ $t("select-employee.select-multiple") }}
        </p>
        <el-switch
          v-model="multipleEmployees.enabled"
          :style="{
            '--schema-color': schemaPrimaryColor,
          }"
        />
      </el-row>
      <div class="body-search-form">
        <el-input
          class="body-search-form-input"
          :placeholder="$t('select-employee.search')"
          prefix-icon="el-icon-search"
          v-model="search"
          clearable
          :style="{
            '--schema-color': schemaPrimaryColor,
          }"
        />
      </div>
      <div class="employees">
        <el-row
          v-for="(employee, index) in filteredEmployees"
          :key="index"
        >
          <router-link
            v-if="!multipleEmployees.enabled"
            :to="{
              name: 'Pay',
              params: {
                qrCode: employee.qrCode,
                currency: $route.params.currency,
              },
            }"
            class="employee"
          >
            <img
              class="employee-img"
              :src="
                `https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${employee.photoUrl ||
                  `${employee.empUid}.png`}?t=${new Date().getTime()}`
              "
              alt="User"
            >
            <h3 class="employee-name">
              {{
                employee.nickName
                  ? employee.nickName
                  : `${employee.name} ${employee.surName}`
              }}
            </h3>
          </router-link>
          <div
            v-else
            :class="[
              'employee',
              multipleEmployees.qrCodes.includes(employee.qrCode)
                ? 'selected'
                : '',
            ]"
            @click="selectEmployee(employee.qrCode)"
          >
            <img
              class="employee-img"
              :src="
                `https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${employee.photoUrl ||
                  'profile.png'}?t=${new Date().getTime()}`
              "
              alt="User"
            >
            <h3 class="employee-name">
              {{
                employee.nickName
                  ? employee.nickName
                  : `${employee.name} ${employee.surName}`
              }}
            </h3>
            <div
              :class="[
                'employee-checkbox',
                multipleEmployees.qrCodes.includes(employee.qrCode)
                  ? 'checked'
                  : '',
              ]"
              :style="{
                '--schema-color': schemaPrimaryColor,
              }"
            />
          </div>
        </el-row>
      </div>
      <div
        v-if="this.employees && filteredEmployees.length === 0"
        class="no-results"
      >
        <h3 class="no-results-title">
          {{ $t("select-employee.no-results-title") }}
        </h3>
        <p class="no-results-subtitle">
          {{ $t("select-employee.no-results-subtitle") }}
        </p>
      </div>
      <el-row
        v-if="multipleEmployees.enabled"
        class="mt-30"
        justify="center"
      >
        <el-button
          :style="{
            backgroundColor: schemaPrimaryColor,
          }"
          type="primary"
          class="primary-button"
          @click="goToMultiplePayment"
        >
          {{ $t("form.next") }}
        </el-button>
      </el-row>
      <el-row class="body-logo">
        <el-link
          class="body-logo-image-link"
          :underline="false"
          href="https://tippie.de"
        >
          <img
            src="@/assets/img/logo.png"
            alt="Tippie"
          >
        </el-link>
        <el-link
          :underline="false"
          class="body-logo-text-link"
          href="https://tippie.de"
        >
          {{ $t("visit-us") }}
        </el-link>
      </el-row>
    </div>
  </div>
</template>

<script>
import router from "@/app/router";

export default {
  name: "SelectEmployee",
  data: () => ({
    fullScreenLoading: true,
    search: "",
    employees: null,
    businessEntity: {},
    multipleEmployees: {
      enabled: false,
      qrCodes: [],
    },
  }),
  computed: {
    schemaPrimaryColor() {
      return this.businessEntity.schemaPrimaryColor || "#FF8A00";
    },
    assignedEmployees: function() {
      return this.employees
        ? this.employees.filter((el) => el.empStatus === "Assigned")
        : [];
    },
    filteredEmployees() {
      const searchText = this.search.toLowerCase();
      return this.assignedEmployees
        .filter((employee) => {
          if (employee.nickName) {
            return employee.nickName.toLowerCase().includes(searchText);
          } else {
            return `${employee.name} ${employee.surName}`
              .toLowerCase()
              .includes(searchText);
          }
        })
        .sort(function(a, b) {
          if (a.surName.toLowerCase() !== b.surName.toLowerCase()) {
            return a.surName.toLowerCase() > b.surName.toLowerCase() ? 1 : -1;
          } else {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : a.name.toLowerCase() === b.name.toLowerCase()
              ? 0
              : -1;
          }
        });
    },
  },
  created() {
    this.$axios
      .get(`api/v1/teams/qrcodes/${this.$route.params.qrCode}`)
      .then((response) => {
        if (response.data.team) {
          this.businessEntity = response.data.businessEntity;
          if (this.checkRedirect()) return;
          this.$axios
            .get(`api/v1/teams/${response.data.team.id}/employees`)
            .then((employees) => {
              this.employees = employees.data;
              this.fullScreenLoading = false;
            })
            .catch(() => {
              this.employees = [];
              this.fullScreenLoading = false;
            });
        } else {
          this.employees = [];
          this.fullScreenLoading = false;
          this.$message.error(
            this.$t("form.validation.format", { field: "QR Code" })
          );
        }
      })
      .catch(() => {
        this.fullScreenLoading = false;
      });
  },
  methods: {
    checkRedirect() {
      const DESIGN_URL = process.env.VUE_APP_NEW_DESIGN_PAYMENT_URL;
      if (this.businessEntity.newDesignPayment && DESIGN_URL) {
        window.location.href = `${DESIGN_URL}/select-employee/${this.$route.params.qrCode}/${this.$route.params.currency}`;
        return true;
      }
    },
    selectEmployee(qrCode = "") {
      if (this.multipleEmployees.qrCodes.includes(qrCode)) {
        this.multipleEmployees.qrCodes.splice(
          this.multipleEmployees.qrCodes.indexOf(qrCode),
          1
        );
      } else {
        this.multipleEmployees.qrCodes.push(qrCode);
      }
    },
    goToMultiplePayment() {
      if (this.multipleEmployees.qrCodes.length) {
        if (this.multipleEmployees.qrCodes.length === 1) {
          router.push({
            name: "Pay",
            params: {
              qrCode: this.multipleEmployees.qrCodes[0],
              currency: "EUR",
            },
          });
        } else {
          router.push({
            name: "MultiplePay",
            params: {
              qrCodes: this.multipleEmployees.qrCodes.join(","),
              currency: "EUR",
            },
          });
        }
      } else {
        this.$message.error("Select at least one person");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.select-container {
  max-width: 1024px;
  margin: 0 auto;
}

.header {
  margin-bottom: 25px;

  &-logo {
    text-align: center;

    img {
      width: 100px;
      height: auto;
      border-radius: 50%;
    }
  }

  &-title {
    color: #2d2e2f;
    font-family: "Raleway Medium", serif;
    font-size: 16px;
    text-align: center;
  }
}

.body {
  padding: 0 12px;

  &-multiple {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 20px 0;

    &__title {
      margin: 0 10px 0 0;
    }
  }

  .employees {
    .employee {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e3e5e5;
      color: #2d2e2f;
      padding: 16px 10px;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        background-color: var(--schema-color);
        color: #fff;

        .employee-name {
          color: #fff;
        }
      }

      &-img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        margin-right: 12px;
      }

      &-name {
        color: #2d2e2f;
        font-weight: 600;
        margin: 0;
      }

      &-checkbox {
        width: 20px;
        height: 20px;
        background: #ffffff;
        border: 3px solid #fff;
        border-radius: 50%;
        box-shadow: 0 0 0 1px var(--schema-color);
        margin: 0 30px 0 auto;

        &.checked {
          background: var(--schema-color);
        }
      }
    }
  }

  &-search-form {
    margin-bottom: 15px;

    &-input::v-deep {
      input {
        border-radius: 8px;
        font-family: "Raleway Medium", serif;
        color: #2d2e2f;

        &:focus {
          border: 1px solid var(--schema-color);
        }
      }
    }
  }

  .no-results {
    margin-top: 140px;
    text-align: center;

    &-title {
      margin-bottom: 8px;
      font-family: "Raleway Bold", serif;
      font-size: 24px;
      color: #2d2e2f;
    }

    &-subtitle {
      margin: 0;
      font-family: "Raleway Medium", serif;
      font-size: 16px;
      color: #b5b5b5;
    }
  }

  &-logo {
    text-align: center;
    margin-top: 40px;
    display: flex;
    flex-direction: column;

    img {
      width: 100px;
      height: 60px;
    }

    a {
      width: max-content;
      margin: 0 auto 10px auto;
    }

    &-image-link {
      width: auto;
      margin: 0 auto;
    }

    &-text-link {
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      width: auto;
      margin: 10px auto 0 auto;
    }
  }
}
</style>
<style lang="scss">
.el-switch.is-checked .el-switch__core {
  background: var(--schema-color);
  border: 1px solid var(--schema-color);
}
</style>
